const initialState = {
	open: false,
	open_user_csv:false
}

const actionTypes = {
    OPEN_CSV_DIALOG: "OPEN_CSV_DIALOG",
    CLOSE_CSV_DIALOG: "CLOSE_CSV_DIALOG",
	OPEN_USER_CSV_DIALOG: "OPEN_USER_CSV_DIALOG",
    CLOSE_USER_CSV_DIALOG: "CLOSE_USER_CSV_DIALOG"
}

export function openCsvDialog(){
    return {
        type: actionTypes.OPEN_CSV_DIALOG,
    }
}

export function closeCsvDialog(){
    return {
        type: actionTypes.CLOSE_CSV_DIALOG,
    }
}

export function openUserCsvDialog(){
    return {
        type: actionTypes.OPEN_USER_CSV_DIALOG,
    }
}

export function closeUserCsvDialog(){
    return {
        type: actionTypes.CLOSE_USER_CSV_DIALOG,
    }
}

export default function (state = initialState, action) {
	switch (action.type) {
		case actionTypes.OPEN_CSV_DIALOG:{
			return { 
				...state,
				open: true,
			}
		}
		case actionTypes.CLOSE_CSV_DIALOG:{
				return { 
					...state,
					open: false,
				}
		}
		case actionTypes.OPEN_USER_CSV_DIALOG:{
			return { 
				...state,
				open_user_csv: true,
			}
		}
		case actionTypes.CLOSE_USER_CSV_DIALOG:{
				return { 
					...state,
					open_user_csv: false,
				}
		}
		default:
			return state
	}
}